// extracted by mini-css-extract-plugin
export default {"wrapper":"Kz-z","viewport":"Lz-z","container":"Mz-z","slide":"Nz-z"};